export default "__VITE_ASSET__92544205__"